import { render, staticRenderFns } from "./crosstabRow.vue?vue&type=template&id=1223a35f&scoped=true"
import script from "./crosstabRow.vue?vue&type=script&lang=js"
export * from "./crosstabRow.vue?vue&type=script&lang=js"
import style0 from "./crosstabRow.vue?vue&type=style&index=0&id=1223a35f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1223a35f",
  null
  
)

export default component.exports